import React, { useState } from "react";
import { Wheel } from "react-custom-roulette";
import { motion, AnimatePresence } from "framer-motion";
import Confetti from "react-confetti";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { transactions } from "@/services/customer";
import { getT } from "@/i18n/translations";

export default function Spin() {
    const t = getT();
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [winner, setWinner] = useState(null);

    const prizes = ([0, 10, 20, 30, 0, 40] || []).map((p) => {
        const pointValue = Number(p);
        return {
            option: pointValue === 0 ? t?.game_betterLuck : `${pointValue} ${t?.game_points}`,
            value: pointValue,
        };
    });

    if (prizes?.length === 0) {
        prizes.push({ option: t?.game_betterLuck, value: 0 });
    }


    const handleSpinClick = () => {
        if (!mustSpin) {
            const newPrizeNumber = Math.floor(Math.random() * prizes.length);
            setPrizeNumber(newPrizeNumber);
            setMustSpin(true);
        }
    };
    const handleWin = async (prize) => {

        const mobile = localStorage.getItem("mobile");
        setLoader(true);

        if (prize.value > 0) {
            const body = {
                activityType: "Games",
                amount: prize.value,
                mobile: mobile?.replace(/^\+91/, ""),
                schemacode: "TSC000337",
            };

            try {
                const token = JSON.parse(localStorage.getItem("token_gen"));
                const res = await transactions(token?.access_token, body);
                if (res?.message === "Request processed successfully.") {
                    setWinner({ ...prize, apiData: res.data });
                } else {
                    setWinner({ option: t.game_betterLuck, value: 0 });
                }
            } catch (error) {
                console.error("Transaction error:", error);
                setWinner({ option: t.game_betterLuck, value: 0 });
            } finally {
                setLoader(false);
            }
        } else {
            setWinner({ option: t.game_betterLuck, value: 0 });
            setLoader(false);
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col items-center"
            style={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#fff5f5",
                backgroundImage:
                    "radial-gradient(circle, #ffd6d6 1px, transparent 1px)",
                backgroundSize: "22px 22px",
            }}
        >
            <div className="w-full max-w-md min-h-screen flex flex-col bg-[#ffe5e5]">

                {/* LOADER */}
                {loader && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 backdrop-blur-sm">
                        <Loader2 className="animate-spin h-10 w-10 text-[#e60012]" />
                    </div>
                )}

                {/* HEADER */}
                <div className="relative flex items-center justify-center px-4 py-4 mt-2 ">
                    <button
                        onClick={() => navigate(-1)}
                        className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full bg-red-50 border border-red-100"
                    >
                        <ArrowLeft className="w-5 h-5 text-[#e60012]" />
                    </button>

                    <p className="text-[15px] font-bold text-[#e60012] tracking-wide">
                        {t.game_spinAndWin}
                    </p>
                </div>

                <div className="px-4 pb-8 space-y-4 flex-1">

                    {/* TOP BANNER */}
                    <div className="rounded-3xl p-5 relative overflow-hidden shadow-md border border-red-100 bg-white">
                        <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-red-100/40" />
                        <div className="absolute -bottom-10 -left-10 w-32 h-32 rounded-full bg-red-100/30" />

                        <div className="relative text-center">

                            <div className="w-14 h-14 rounded-full bg-red-100 border border-red-200 flex items-center justify-center mx-auto mb-3">
                                <span className="text-2xl">🎯</span>
                            </div>

                            <p className="text-[11px] font-semibold tracking-widest text-[#e60012] uppercase mb-1">
                                Coca-Cola Lucky Spin
                            </p>

                            <h2 className="text-[22px] font-bold text-[#111] mb-2">
                                {t.game_spinAndWin}
                            </h2>

                            <p className="text-[12px] text-gray-500">
                                Spin the wheel and win exciting rewards instantly.
                            </p>
                        </div>
                    </div>

                    {/* WHEEL CARD */}
                    <div className="bg-white rounded-3xl shadow-md p-5 relative overflow-hidden border border-red-100">

                        {/* WHEEL */}
                        <div className="flex justify-center scale-[0.82] sm:scale-[0.9] origin-center">
                            <Wheel
                                mustStartSpinning={mustSpin}
                                prizeNumber={prizeNumber}
                                data={prizes}
                                onStopSpinning={() => {
                                    setMustSpin(false);
                                    const prize = prizes[prizeNumber];
                                    handleWin(prize);
                                }}

                                outerBorderColor="#ffffff"
                                outerBorderWidth={3}
                                radiusLineColor="#ffffff"
                                radiusLineWidth={2}

                                textColors={["#111111"]}

                                fontSize={window.innerWidth < 400 ? 11 : 14}

                                backgroundColors={[
                                    "#F40009",
                                    "#B80000",
                                    "#FF1E1E",
                                    "#D60000",
                                    "#8B0000",
                                    "#FF4D4D",
                                ]}

                                width={
                                    window.innerWidth < 400
                                        ? 180
                                        : window.innerWidth < 768
                                            ? 210
                                            : 230
                                }
                            />
                        </div>

                        {/* SPIN BUTTON */}
                        <button
                            onClick={handleSpinClick}
                            disabled={mustSpin}
                            className={`w-full mt-6 py-4 rounded-2xl text-[15px] font-bold text-white transition-transform active:scale-[0.98] ${mustSpin ? "opacity-60 cursor-not-allowed" : ""
                                }`}
                            style={{
                                background: "linear-gradient(90deg, #e60012, #ff1a1a)",
                            }}
                        >
                            {t.game_spin}
                        </button>
                    </div>
                </div>

                {/* FOOTER */}
                {/* <div className="w-full py-3 border-t">
                    <p className="text-[13px] text-[#e60012] uppercase text-center font-semibold tracking-wide">
                        © {new Date().getFullYear()} Consumer Journeys. All Rights Reserved.
                    </p>
                </div> */}
            </div>

            {/* WINNER POPUP */}
            <AnimatePresence>
                {winner && (
                    <motion.div
                        className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 px-4"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.5 }}
                    >
                        <div className="bg-white rounded-3xl shadow-2xl p-7 w-full max-w-sm text-center border border-red-100">

                            {winner.value > 0 ? (
                                <>
                                    <div className="w-16 h-16 rounded-full bg-red-100 border border-red-200 flex items-center justify-center mx-auto mb-4">
                                        <span className="text-3xl">🎉</span>
                                    </div>

                                    <p className="text-[11px] font-semibold text-[#e60012] uppercase tracking-widest mb-2">
                                        Congratulations
                                    </p>

                                    <h2 className="text-[22px] font-bold text-[#111] mb-2">
                                        {t.game_youWon}
                                    </h2>

                                    <p className="text-sm text-gray-500 mb-6">
                                        You won{" "}
                                        <span className="font-bold text-[#e60012]">
                                            {winner.option}
                                        </span>
                                    </p>
                                </>
                            ) : (
                                <>
                                    <div className="w-16 h-16 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center mx-auto mb-4">
                                        <span className="text-3xl">😔</span>
                                    </div>

                                    <h2 className="text-[22px] font-bold text-[#111] mb-2">
                                        {t.game_betterLuck}
                                    </h2>

                                    <p className="text-sm text-gray-500 mb-6">
                                        {t.game_dontWorry}
                                    </p>
                                </>
                            )}

                            <button
                                onClick={() => setWinner(null)}
                                className="w-full py-3 rounded-xl text-white font-semibold"
                                style={{
                                    background: "linear-gradient(90deg, #e60012, #ff1a1a)",
                                }}
                            >
                                {t.game_playAgain}
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* CONFETTI */}
            {winner?.value > 0 && (
                <Confetti width={window.innerWidth} height={window.innerHeight} />
            )}
        </div>
    );
}
